var $a9cedf75b94e4916$exports = {};
$a9cedf75b94e4916$exports = {
  "alpha": "Alpha",
  "black": "\u9ED1\u8272",
  "blue": "\u84DD\u8272",
  "blue purple": "\u84DD\u7D2B\u8272",
  "brightness": "\u4EAE\u5EA6",
  "brown": "\u68D5\u8272\u7684",
  "brown yellow": "\u68D5\u9EC4\u8272",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "\u84DD\u7EFF\u8272",
  "cyan blue": "\u9752\u84DD\u8272",
  "dark": "\u6DF1\u8272",
  "gray": "\u7070\u8272",
  "grayish": "\u6D45\u7070\u8272\u7684",
  "green": "\u7EFF\u8272",
  "green cyan": "\u7EFF\u9752\u8272",
  "hue": "\u8272\u76F8",
  "light": "\u6D45\u8272",
  "lightness": "\u660E\u4EAE\u5EA6",
  "magenta": "\u7D2B\u7EA2\u8272",
  "magenta pink": "\u7D2B\u7C89\u8272",
  "orange": "\u6A59\u8272",
  "orange yellow": "\u6A59\u9EC4\u8272",
  "pale": "\u82CD\u767D\u7684",
  "pink": "\u7C89\u8272",
  "pink red": "\u7C89\u7EA2\u8272",
  "purple": "\u7D2B\u8272",
  "purple magenta": "\u7D2B\u6D0B\u7EA2\u8272",
  "red": "\u7EA2\u8272",
  "red orange": "\u7EA2\u6A59\u8272",
  "saturation": "\u9971\u548C\u5EA6",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", ").concat(args.percentTransparent, " \u900F\u660E");
  },
  "very dark": "\u5F88\u6697",
  "very light": "\u5F88\u6D45",
  "vibrant": "\u751F\u673A\u52C3\u52C3",
  "white": "\u767D\u8272",
  "yellow": "\u9EC4\u8272",
  "yellow green": "\u9EC4\u8272/\u7EFF\u8272"
};
export { $a9cedf75b94e4916$exports as default };